import React from 'react';

interface DynamicFormattingProps {
  type: string;
  label: string;
}

export default function DynamicFormatting({ type, label }: DynamicFormattingProps) {
  return (
    <div className={`dynamic-form-${type}`}>{`${label}`}</div>
  );
}
